
import React from "react";

const ConsultancyFooter = () => {
  return (
    <footer className="main-footer">
      <div className="container">

        {/* ===== Upper Box ===== */}
        <div className="upper-box">
          <div className="logo" style={{ 'marginLeft': '-25px' }}>
            <a href="/">
              <img src="/images/logo-footer.png" alt="Stusphere" />
            </a>
          </div>
        </div>

        {/* ===== Widgets Section ===== */}
        <div className="widgets-section">
          <div className="row" style={{ 'marginTop': '18px' }}>

            {/* About */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget">
                <h4>About Us</h4>
                <p className="text" style={{color:'white'}}>
                  Stusphere is a Business firm with record of winning many
                  projects under tough circumstances.
                </p>
              </div>
            </div>

            {/* Company */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget">
                <h4>Company</h4>
                <ul className="links">
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/contact">Contact Us</a></li>
                  <li><a href="/termsAndPolicy">Terms & Policy</a></li>
                </ul>
              </div>
            </div>

            {/* Products */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget">
                <h4>Products</h4>
                <ul className="links">
                  <li><a href="#">HRMS Payroll Software</a></li>
                  <li><a href="#">Employee Finance</a></li>
                  <li><a href="#">Leave Management Software</a></li>
                  <li><a href="#">Online Payroll</a></li>
                </ul>
              </div>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget">
                <h4>Contact Us</h4>
                <ul className="contact-list">
                  <li>
                    <span className="icon fa fa-phone"></span>
                    <a href="tel:+919999999999">+1 (555) 123-4567</a>
                  </li>
                  <li>
                    <span className="icon fa fa-envelope"></span>
                    <a href="mailto:stusphere@email.com">
                      stusphere@email.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* ===== LOCATION (FULL WIDTH) ===== */}
            <div className="col-lg-12">
              <div className="location-wrapper">
                <h4 className="location-main-title">Our Locations</h4>

                <div className="location-grid">

                  <div className="location-card">
                    <span className="fa fa-map-marker"></span>
                    <h6>Head Office</h6>
                    <p>Dehradun, Uttarakhand, India</p>
                  </div>

                  <div className="location-card">
                    <span className="fa fa-map-marker"></span>
                    <h6>India Office</h6>
                    <p>
                      Hanuman Nagar, Near Collectorate<br />
                      Chapra, Saran, Bihar – 841301
                    </p>
                  </div>

                  <div className="location-card">
                    <span className="fa fa-map-marker"></span>
                    <h6>US Office</h6>
                    <p>Miramar, FL 33025, United States</p>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ===== Footer Bottom ===== */}
        

        <div className="footer-bottom" style={{marginTop: '27px'}}>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="left-box">
              <div className="copyright">
                &copy; 2026 <a href="#">Stusphere</a>, All Rights Reserved
              </div>
            </div>
            <div className="right-box d-flex">
              {/* <!-- Social Box --> */}
              <ul className="social-box">
                <li>
                  <a
                    href="https://www.facebook.com/"
                    className="fa fa-facebook-f"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/"
                    className="fa fa-instagram"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.twitter.com/"
                    className="fa fa-twitter"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/"
                    className="fa fa-linkedin"
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ConsultancyFooter;
